import React from 'react'

function RamaPhayathai() {
  return (
    <div>โรงพยาบาลรามาธิบดี วิทยาเขตพญาไท</div>
  )
}

export default RamaPhayathai